module.exports = __webpack_public_path__ + "img/coolicon.59fa9331.svg";